import { Capacitor } from '@capacitor/core';

const trimOrigin = (value?: string) => (value ?? '').trim().replace(/\/+$/, '');

/**
 * The admin section lives on its own name (admin.roade.ro, admin.dev.roade.ro). Unset in local
 * development and ignored in the native app, where the admin section stays inside the app.
 */
export const adminSiteUrl = (): string => (Capacitor.isNativePlatform()
  ? ''
  : trimOrigin(import.meta.env.VITE_ADMIN_SITE_URL));

export const publicSiteUrl = (): string => trimOrigin(import.meta.env.VITE_SITE_URL);

export const isAdminSite = (): boolean => {
  const admin = adminSiteUrl();
  return Boolean(admin) && window.location.origin === admin;
};

/** Pages the admin site serves; any other page opens on the public site. */
export const ADMIN_SITE_PAGES = new Set(['administration', 'login', 'resetPassword']);

const currentPath = () => `${window.location.pathname}${window.location.search}`;

/** Where the current URL belongs when it is on the wrong site, or null when it is fine here. */
export const siteRedirectTarget = (page: string): string | null => {
  const admin = adminSiteUrl();
  if (!admin) return null;
  if (isAdminSite()) {
    // CloudFront sends "/" to /administration, but the service worker can answer "/" from cache.
    if (page === 'home') return `${admin}/administration`;
    return ADMIN_SITE_PAGES.has(page) ? null : `${publicSiteUrl()}${currentPath()}`;
  }
  return page === 'administration' ? `${admin}${currentPath()}` : null;
};
